import {
  FAILURE_FETCH_COMPANY,
  FAILURE_UPDATE_COMPANY,
  REQUEST_FETCH_COMPANY,
  REQUEST_UPDATE_COMPANY,
  RESET_COMPANY,
  SUCCESS_FETCH_COMPANY,
  SUCCESS_UPDATE_COMPANY,
} from 'actions/actionTypes';
import { BackendCompanyState, CompanyActionTypes } from 'types/backend/company';

export const initialState: BackendCompanyState = {
  currentCompany: null,
  isFailureFetchCompany: false,
};

const backendCompanyReducer = (
  state = initialState,
  action: CompanyActionTypes,
): BackendCompanyState => {
  switch (action.type) {
    case REQUEST_FETCH_COMPANY: {
      return {
        ...state,
      };
    }
    case SUCCESS_FETCH_COMPANY: {
      const { payload } = action;

      return {
        ...state,
        currentCompany: payload,
        isFailureFetchCompany: false,
      };
    }
    case FAILURE_FETCH_COMPANY: {
      return {
        ...state,
        isFailureFetchCompany: true,
      };
    }
    case REQUEST_UPDATE_COMPANY: {
      return {
        ...state,
      };
    }
    case SUCCESS_UPDATE_COMPANY: {
      const { payload } = action;
      return {
        ...state,
        currentCompany: payload,
      };
    }
    case FAILURE_UPDATE_COMPANY: {
      return {
        ...state,
      };
    }
    case RESET_COMPANY: {
      return {
        ...state,
        currentCompany: initialState.currentCompany,
        isFailureFetchCompany: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default backendCompanyReducer;
